module.exports = "/images/icon_feather_home.svg?f8ed5f08f23e51988b4296ef8f7854f8";